'use strict';

// START CUSTOM KENZO
window.jQuery = window.$ = require('jquery');
// END CUSTOM KENZO

const kleepUtils = require('./kleepUtils');

const LABEL_STORAGE_KEYS = {
    mid: 'kleep_mid',
    uid: 'kleep_user_uuid'
};

/**
 * Asynchronously posts result data to a specified endpoint.
 * @async
 * @param {{ productId: string, measurePublicId: string }} data - An object containing product ID, hash, and identifier.
 * @returns {Promise<{statusCode: number, body: string}>} The response data from the endpoint.
 */
const postResult = async ({ productId, measurePublicId }) => {
    const kleepRecommendEndpoint = $('.kleep-button').data('url');

    const recommendData = {
        product_reference: productId,
        measure_public_id: measurePublicId,
        variant_reference_active : '12121'
    };

    try {
        const response = await fetch(kleepRecommendEndpoint, {
            method: 'POST',
            headers: {'Content-Type': 'application/json; charset=utf-8'},
            body: JSON.stringify(recommendData)
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        return await response.json();
    } catch (error) {
        console.error('[Kleep] Error in postResult: ', error);
        throw error;
    }
};

/**
 * Toggles the display of multiple DOM elements.
 * @param {jQuery} $elements - jQuery object containing elements to toggle.
 * @param {boolean} show - Determines whether to show or hide the elements.
 */
const toggleDOMElements = ($elements, show) => {
    if (show) {
        $elements.show();
        if ($elements.hasClass('kleep-iframe-wrapper')) {
            $('[is="o-navigation"]').css('z-index', '0'); // CUSTOM KENZO
        }
    } else {
        $elements.hide();
        if ($elements.hasClass('kleep-iframe-wrapper')) {
            $('[is="o-navigation"]').css('z-index', ''); // CUSTOM KENZO
        }
    }
}

/**
 * Load the result based on the stored data.
 * @param {string} productId
 */
const loadResult = async productId => {
    const mid = localStorage.getItem(LABEL_STORAGE_KEYS.mid);
    const $defaultTextSpans = $('.kleep-default');
    const $customTextSpans = $('.kleep-custom');

    if (!mid) {
        toggleDOMElements($defaultTextSpans, true);
        toggleDOMElements($customTextSpans, false);
        return;
    }


    try {
        const data = await withTimeout(
            postResult({ productId, measurePublicId: mid }),
            3000  // Timeout after 3000ms
        );

        const $resCustomTextSpan = $('.kleep-custom-res');

        if (data.result && data.result.recommendation && data.result.recommendation.length > 0 && $resCustomTextSpan.length) {
            $resCustomTextSpan.text(data.result.recommendation[0].label);

            toggleDOMElements($defaultTextSpans, false);
            toggleDOMElements($customTextSpans, true);
        } else {
            toggleDOMElements($defaultTextSpans, true);
            toggleDOMElements($customTextSpans, false);
        }
    } catch (error) {
        console.warn('[Kleep] Failed to get result: ', error);

        toggleDOMElements($defaultTextSpans, true);
        toggleDOMElements($customTextSpans, false);
    }
};

function withTimeout(promise, ms) {
    return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
            reject(new Error('Request timed out after ' + ms + ' milliseconds'));
        }, ms);
        promise.then(
            res => {
                clearTimeout(timeoutId);
                resolve(res);
            },
            err => {
                clearTimeout(timeoutId);
                reject(err);
            }
        );
    });
}

function initRecommendationIframeLoading() {
    if ($('.kleep-iframe').length === 0) {
        const $iframeWrapper = $('.kleep-iframe-wrapper').first();

        const $iframe = $('<iframe>', {
            class: 'kleep-iframe',
            src: $iframeWrapper.data('iframeSrc'),
            title: $iframeWrapper.data('iframeTitle'),
            style: 'border:none;'
        });

        $iframeWrapper.append($iframe);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initRecommendationIframeLoading();

    window.KleepSDK = (function() {
        const sdk = {};

        sdk.addToCart = function(data) {
            $('body').trigger('product:beforeAddToCart');
            try {
                const addToCartUrl = kleepUtils.getAddToCartUrl();

                if (addToCartUrl) {
                    $.ajax({
                        url: addToCartUrl,
                        method: 'POST',
                        data: data,
                        success: handleSuccess,
                        error: handleError
                    });
                }
            } catch (error) {
                console.error('[Kleep] Error in addToCart: ', error);
            }
        };

        function handleSuccess(data) {
            kleepUtils.handlePostCartAdd(data);
            $('body').trigger('product:afterAddToCart', data);
            // START CUSTOM KENZO
            document.dispatchEvent(new CustomEvent('oNavigation:updateCartCount', {
                detail: {
                    productCount: data.quantityTotal
                }
            }));
            document.dispatchEvent(new CustomEvent('oSidebarAjax:prepareAndSendEvent', { detail: { sidebarId: 'o-sidebar-miniCart' } }));
            // END CUSTOM KENZO
        }

        function handleError() {
            console.error('[Kleep] Error processing addToCart.');
        }

        return sdk;
    })();
});

async function updateKleepRecommendData(pid) {
    try {
        const response = await fetch($('.js-kleep-update-recommend-data').val(), {
            method: 'POST',
            headers: {'Content-Type': 'application/json; charset=utf-8'},
            body: JSON.stringify({
                pid: pid
            })
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        return await response.json();
    } catch (error) {
        console.error(`[Kleep] Error in updateKleepRecommendData: `, error);
        throw error;
    }
}

document.addEventListener('DOMContentLoaded', async () => {
    const $componentButtons = $('.kleep-button');
    const $componentIframeWrapper = $('.kleep-iframe-wrapper').first();
    const $componentIframe = $('.kleep-iframe');
    const productId = $componentButtons.data('productId') || '';
    const recommendationType = $componentButtons.data('recommendationType') || '';

    $('body').on('product:updateAvailability', function (e, response) {
        if (response.product && response.product.id) {
            updateKleepRecommendData(response.product.id).then(data => {
                if (data && data.success) {
                    $componentIframe.attr('src', data.kleepModalURL);
                    $componentButtons.attr('data-product-id', data.kleepPid);
                }
            }).catch(error => handleError('update availability', error));
        }
    });

    toggleDOMElements($componentButtons, true);

    loadResult(productId);

    function onIframeLoad() {
        toggleDOMElements($componentIframeWrapper, true);
        $componentIframe.off('load', onIframeLoad);
    }

    function onButtonClick() {
        if ($componentIframe) {
            $componentIframe.on('load', onIframeLoad);
            $componentIframe.attr('src', $componentIframe.attr('src'));  // Force reload
        }
    }

    const originHost = new URL($componentIframeWrapper.data('iframeUrl')).origin;

    function onMessage(event) {
        const eventData = event.data;
        if (typeof eventData === 'string') {
            return;
        }
        if ('name' in eventData && eventData.name === "kleep_request_uuids") {
            require('./kleepUtils').sendKleepUUIDsToIframes(sessionStorage.getItem("kleep_session_uuid"), localStorage.getItem('kleep_user_uuid'));
        }

        if (!eventData || (event.origin !== originHost)) {
            return;
        }

        switch (eventData.action) {
            case 'clearMid':
                localStorage.removeItem(LABEL_STORAGE_KEYS.mid);
                loadResult(productId);
                break;
            case 'clearUid':
                localStorage.removeItem(LABEL_STORAGE_KEYS.uid);
                break;
            case 'addToCart':
                try {
                    window.KleepSDK.addToCart({
                        pid: eventData.variantId,
                        quantity: 1
                    });
                } catch (error) {
                    console.error('[Kleep] KleepSDK.addToCart error: ', error);
                }
                break;
            case 'closeIframe':
                toggleDOMElements($componentIframeWrapper, false);
                loadResult(productId);
                break;
        }

        if (eventData.data === 'mid' && eventData.mid) {
            localStorage.setItem(LABEL_STORAGE_KEYS.mid, eventData.mid);
        }
        if (eventData.data === 'uid' && eventData.uid) {
            localStorage.setItem(LABEL_STORAGE_KEYS.uid, eventData.uid);
        }
    }

    if ($componentButtons.length) {
        $('body').on('click', '.kleep-button', onButtonClick);
    }

    window.addEventListener('message', onMessage);
});
